import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const ModuleSubtopicSeparationVariables = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="METHOD OF SEPARATION OF VARIABLES"
      videos={["https://www.youtube.com/embed/DgvQzfLpaTY"]}
      takeaways={[
        { text: "Practice as many problems as you can" },
      ]}
      questions={[]} // No questions provided
      exampleVideos={[]} // No example videos provided
    />
);
}

export default ModuleSubtopicSeparationVariables;
